<template>
  <main class="main">
    <!-- 渲染 route 的位置 -->
    <router-view></router-view>
  </main>
</template>
